import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import MaskedInput from "antd-mask-input";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { openNotification } from "src/components/helpers/notification";
import {
  editTraining,
  getClientTrainings,
} from "src/store/Slices/ClientsSlice";

const EditTrainingModal = ({
  visible,
  setVisible,
  trainingInfo,
  clientInfo,
}) => {
  // HELPERS
  const dispatch = useDispatch();
  const dateFormatList = ["DD.MM.YYYY"];

  // STATE
  const [trainingCount, setTrainingCount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [abonementRegistrationDate, setAbonementRegistrationDate] =
    useState("");
  // FUNCTIONS
  const onClickEditTraining = () => {
    if (userPhone?.includes("_") && userPhone !== "+_ (___) ___-__-__") {
      openNotification({
        type: "error",
        message:
          "Проверьте правильность введённых номеров. Все номера должны быть заполнены полностью",
      });
    } else {
      dispatch(
        editTraining({
          trainingPackId: trainingInfo?.id,
          trainingLeft: trainingCount,
          startDate: dayjs(startDate, "DD.MM.YYYY").format(
            "YYYY-MM-DDTHH:mm:ss"
          ),
          endDate: dayjs(endDate, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          userPhone: userPhone === "+_ (___) ___-__-__" ? "" : userPhone,
          abonementRegistrationDate: dayjs(endDate, "DD.MM.YYYY").format(
            "YYYY-MM-DDTHH:mm:ss"
          ),
        })
      ).then(() => {
        dispatch(getClientTrainings({ clientId: clientInfo.id }));
        setVisible(false);
      });
    }
  };

  useEffect(() => {
    if (trainingInfo) {
      setTrainingCount(trainingInfo?.trainingsLeft);
      setStartDate(trainingInfo?.startDate);
      setEndDate(trainingInfo?.endDate);
      setAbonementRegistrationDate(trainingInfo?.startDate);
      setUserPhone(trainingInfo?.userPhone);
    }
  }, [visible]);

  return (
    <>
      <CModal
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="VerticallyCenteredExample"
      >
        <CModalHeader>
          <CModalTitle id="VerticallyCenteredExample">
            Изменить тренировку
          </CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Flex vertical gap={16} style={{ marginTop: "20px" }}>
            <>
              <div>
                <Typography.Title
                  level={5}
                >{`Остаток тренировок (Остаток :  ${trainingInfo?.trainingCount})[Обязательно]`}</Typography.Title>
                <Input
                  defaultValue=""
                  type="number"
                  value={trainingCount}
                  onChange={(e) => {
                    setTrainingCount(
                      trainingInfo?.trainingCount >= e.currentTarget.value &&
                        e.currentTarget.value >= 0
                        ? e.currentTarget.value
                        : 0
                    );
                  }}
                />
              </div>

              <div>
                <Typography.Title level={5}>Начало действия</Typography.Title>
                <DatePicker
                  style={{ width: "100%" }}
                  format={"DD.MM.YYYY"}
                  placement={"topRight"}
                  onChange={(date, dateString) => {
                    setStartDate(date);
                  }}
                  defaultValue={dayjs(startDate, dateFormatList)}
                />
              </div>

              <div>
                <Typography.Title level={5}>Конец действия</Typography.Title>
                <DatePicker
                  style={{ width: "100%" }}
                  format={"DD.MM.YYYY"}
                  placement={"topRight"}
                  onChange={(date, dateString) => {
                    setEndDate(date);
                  }}
                  defaultValue={dayjs(endDate, dateFormatList)}
                />
              </div>

              <div>
                <Typography.Title level={5}>
                  Дата регистрации абонемента
                </Typography.Title>
                <DatePicker
                  style={{ width: "100%" }}
                  format={"DD.MM.YYYY"}
                  placement={"topRight"}
                  onChange={(date, dateString) => {
                    setAbonementRegistrationDate(date);
                  }}
                  defaultValue={dayjs(
                    abonementRegistrationDate,
                    dateFormatList
                  )}
                />
              </div>

              <div>
                <Typography.Title level={5}>Номер телефона</Typography.Title>
                <MaskedInput
                  className="custom-input"
                  mask="+{0} (000) 000-00-00"
                  value={userPhone}
                  onChange={(e) => {
                    setUserPhone(e.target.value);
                  }}
                />
              </div>
            </>
          </Flex>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary text-light"
            onClick={() => {
              setVisible(false);
            }}
          >
            Закрыть
          </CButton>
          <CButton color="primary text-light" onClick={onClickEditTraining}>
            Сохранить
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default EditTrainingModal;
